module.exports = __webpack_public_path__ + "static/img/active7.cd148af7.png";